import React, { useEffect, useState } from "react";
import { useHistory, useParams } from "react-router";

import { Role } from "@teamrota/authlib";

import {
  RotaButtonNew,
  RotaSearchInput,
  RotaButtonIcon,
  iconNew
} from "@teamrota/rota-design";

import useAuth from "~/src/auth/hooks/use-auth";
import HasRole from "~/src/containers/has-role";

import {
  Wrapper,
  HeaderWrapper,
  Box,
  Heading,
  Title,
  Actions,
  Subheader,
  SubheaderWrapper
} from "~/src/components/payroll/style";

import JsonEditModal from "../payroll/components/JsonEditModal";

import Table from "./Table";

import { useCreatePayrollCalculation } from "./graphql/use-create-payroll-calculation";
import { useUpdatePayrollCalculation } from "./graphql/use-update-payroll-calculation";
import { usePayrollCalculations } from "./graphql/use-payroll-calculations";

import { useValidatePayrollCalculation } from "./graphql/use-validate-payroll-calculation";

const { Filter, ChevronLeft } = iconNew;

const ExampleJsonInput = {
  name: "Name",
  config: [
    {
      name: "PRSI",
      factor: 1.17,
      of: "PAY"
    }
  ]
};

const Calculations = () => {
  const history = useHistory();
  const params = useParams() as any;
  const auth = useAuth();

  const canEdit = auth.hasRole(Role.PAYROLL_EDIT);

  const { createPayrollCalculation } = useCreatePayrollCalculation();
  const { validatePayrollCalculation } = useValidatePayrollCalculation();
  const { updatePayrollCalculation } = useUpdatePayrollCalculation();

  const { payrollCalculations } = usePayrollCalculations("");

  const [isShowCreateModal, setIsShowCreateModal] = useState(false);
  const [selectedOpenId, setSelectedOpenId] = useState<string>("");

  useEffect(() => {
    if (params.id !== undefined) {
      if (payrollCalculations.find((p: any) => p.id === params.id)) {
        setSelectedOpenId(params.id);
      }
    }
  }, [params, payrollCalculations]);

  const handleOpenCalculation = (id: string) => setSelectedOpenId(id);

  const handleClose = () => {
    setSelectedOpenId("");
    history.push("/payroll/calculations");
  };

  return (
    <Wrapper>
      <HeaderWrapper>
        <RotaSearchInput onChange={() => {}} />
        <HasRole role={Role.PAYROLL_EDIT}>
          <RotaButtonNew onClick={() => setIsShowCreateModal(true)}>
            Create
          </RotaButtonNew>
        </HasRole>
      </HeaderWrapper>
      <SubheaderWrapper>
        <RotaButtonIcon onClick={() => history.push("/payroll")}>
          <ChevronLeft />
        </RotaButtonIcon>
        <Subheader>Calculations</Subheader>
      </SubheaderWrapper>
      <Box>
        <Heading>
          <Title>{`All ${payrollCalculations?.length} records`}</Title>
          <Actions>
            <RotaButtonIcon onClick={() => {}}>
              <Filter />
            </RotaButtonIcon>
          </Actions>
        </Heading>

        <Table
          payrollCalculations={payrollCalculations}
          handleOpenCalculation={handleOpenCalculation}
          canEdit={canEdit}
        />
      </Box>

      {isShowCreateModal && (
        <JsonEditModal
          canEdit={canEdit}
          onSave={async ({ name, config }) => {
            await createPayrollCalculation({ name, config });
            setIsShowCreateModal(false);
          }}
          onValidate={({ name, config }) =>
            validatePayrollCalculation({ name, config })
          }
          onClose={() => setIsShowCreateModal(false)}
          value={ExampleJsonInput}
          title="Create charge calculations"
        />
      )}

      {selectedOpenId && (
        <JsonEditModal
          canEdit={canEdit}
          onSave={async ({ name, config }) => {
            await updatePayrollCalculation({
              id: selectedOpenId,
              name,
              config
            });
            handleClose();
          }}
          onValidate={({ name, config }) =>
            validatePayrollCalculation({ name, config })
          }
          onClose={handleClose}
          value={payrollCalculations.find(
            ({ id }: { id: string }) => id === selectedOpenId
          )}
          title="Edit charge calculations"
        />
      )}
    </Wrapper>
  );
};

export default Calculations;
